import React,{useContext, useEffect,useState,useRef} from 'react'
import axios from 'axios'
import {useNavigate } from 'react-router-dom'
import {UserContext} from '../context/UserContext'
import {Form} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { countries} from 'countries-list'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

import Panel from '../ui/Panel'
import Btn from '../ui/Btn'
import Avatar from '../ui/Avatar'
import './profile.css'

export default function Profile() {
    const {isAuth,setIsAuth}=useContext(UserContext)
    const {apiToken,setApiToken} = useContext(UserContext)
    const {userID,setUserID }= useContext(UserContext)
    const {usrPhoto,setUsrPhoto}= useContext(UserContext)
    const {firstName,lastName}= useContext(UserContext)
    const [isLoading,setIsLoading]=useState(false)
    const [file,setFile]=useState(null)
    const [fileType,setFileType]=useState('')
    const [image, setImage] = useState(null);
    const [appCountries,setAppCountries]=useState([])
    const [err,setErr]=useState(false)
    const [uploadPercentage, setUploadPercentage]=useState(0)
    const [isUploading, setIsUpLoading]=useState(false)
    const [pickedImage,setPickedImage]=useState(false)

    // The context value is empty on a hard refresh — fall back to what the
    // last successful upload wrote into sessionStorage.
    const resolvePhoto=()=>{
      try{
        if (usrPhoto) return usrPhoto
        const stored=sessionStorage.getItem('usrPhoto')
        if (stored) return stored
      }catch(xerr){}
      return ''
    }

    const [tempPhoto,setTempPhoto]=useState(resolvePhoto)
    const [photoBroken,setPhotoBroken]=useState(false)
    const [uploadNote,setUploadNote]=useState(null)
    const [saveNote,setSaveNote]=useState(null)
      const [record,setRecord]=useState({
        FullName:'',
        VatNumber:'',
        Password:'',
        Email:'',
        Country:'',
        Telephone:'',
        telPrefix:'',
        EndDateDisplay:'1 2 3 4 '


      })
    const navigate=useNavigate()
    const fileInputRef=useRef()

    useEffect(()=>{

        //loadImage()
        loadProfile()
        loadCountries()
    },[])

    // A fresh url is always worth another try — clear the broken flag.
    useEffect(()=>{
      setPhotoBroken(false)
    },[tempPhoto])

    // The photo url can arrive after the first paint (context or a fresh upload).
    useEffect(()=>{
      if (pickedImage) return
      const next=resolvePhoto()
      if (next && next!==tempPhoto){
        setTempPhoto(next)
      }
    },[usrPhoto])

    const loadProfile=()=>{
      //setIsLoading(true)
      axios.get(process.env.REACT_APP_API_SERVER+'manager/profile/'+sessionStorage.getItem('userToken'),{
        headers: {
            'Authorization': 'Bearer '+sessionStorage.getItem("mngapiToken")
            }
        })
      .then(res=>{

          setRecord(res.data.results[0])
          setIsLoading(false)
      }).catch(err=>{
          console.log(err)
          setIsLoading(false)

      })
  }

  const loadCountries=()=>{
    setIsLoading(true)
    axios.get(process.env.REACT_APP_API_SERVER+'manager/eshopcountries')
    .then(res=>{
      if (res.data.err===0){

          setAppCountries(res.data.results)

      }else{
        setErr(true)
      }
      setIsLoading(false)
    }).catch(xerr=>{
        setErr(true)
        setIsLoading(false)
    })
  }

    // Turns an axios failure into something the user can act on.
    const describeUploadError=(xerr)=>{
        const status=(xerr && xerr.response) ? xerr.response.status : 0
        if (status===401 || status===403){
          return 'The server refused the request as unauthorised. Sign out, sign in again and retry the upload.'
        }
        if (status===413){
          return 'The image is too large for the server. Try a file under 2 MB.'
        }
        if (status>=500){
          return 'The server could not store the image. Please try again in a moment.'
        }
        if (status===0){
          return 'The server could not be reached. Check your connection and try again.'
        }
        return 'The upload did not complete (error '+status+'). Please try again.'
    }

    const uploadFile=async (xfile)=>{
        if (!xfile){
          setUploadNote({tone:'bad',title:'No image selected',text:'Pick a JPG or PNG first, then press Upload.'})
          return
        }

        setUploadNote(null)
        setIsUpLoading(true)
        setPickedImage(false)
        const formData=new FormData()
        const imgNameArr=xfile.name.split('.')
        const ImgExtension=imgNameArr[imgNameArr.length-1]


        formData.append('file',xfile)

        // CustomerUUID, not ChatUserUUID: the latter is empty for any manager who
        // is not also a player, which is most of them, and the server then failed
        // trying to decrypt an empty string.
        formData.append('id',sessionStorage.getItem('userToken'))
        formData.append('imgExtension',ImgExtension)


        axios.post(process.env.REACT_APP_API_SERVER+'manager/profile/uploadphoto',formData,{
            headers: {
                'Authorization': 'Bearer '+sessionStorage.getItem("mngapiToken"),
                'Content-Type':'multipart/form-data'
              },
              onUploadProgress: ProgressEvent=>{
                  setUploadPercentage(parseInt(Math.round(ProgressEvent.loaded*100/ProgressEvent.total)))

              }
          })
          .then(res=>{

              if (res.data.err==0){
               //setVideo(res.data.fileID)
               setUploadPercentage(0)
               setIsUpLoading(false)
                loadImage()
               //loadUserDetails()
               setUploadNote({tone:'good',title:'Photo updated',text:'Your new profile photo is now live across the manager.'})
              }else{
                setUploadPercentage(0)
                setIsUpLoading(false)
                setPickedImage(true)
                setUploadNote({
                  tone:'bad',
                  title:'Upload rejected',
                  text:(res.data.msg ? String(res.data.msg)+' ' : 'The server did not accept the file. ')+'Try a smaller JPG or PNG.'
                })
              }

          }).catch(err=>{
            setUploadPercentage(0)
            setIsUpLoading(false)
            setPickedImage(true)
            setUploadNote({tone:'bad',title:'Upload failed',text:describeUploadError(err)})
          })
      }

    const selectMedia=()=>{
        fileInputRef.current.click();
    }

    const handleFileChange=(e)=>{
      try{
          if (e.target.files[0].type.includes('image')){
            setUploadNote(null)
            setFile(e.target.files[0])
            setFileType('p')
            const reader = new FileReader();

            reader.onloadend = () => {
              setTempPhoto(reader.result);
              setPickedImage(true)
            };

            if (e.target.files[0]) {
              reader.readAsDataURL(e.target.files[0]);
            }
          }else{
            setUploadNote({tone:'bad',title:'Unsupported file',text:'That file is not an image. Choose a JPG or PNG.'})
          }
            // if (e.target.files[0].type.includes('image')){
            //     setFileType('p')
            //     uploadFile(e.target.files[0])
            // }
        }catch(err){

        }
    }

    const loadImage=()=>{
        const d=Date.now()
        //alert(`${process.env.REACT_APP_API_SERVER}files/${userID}/${d}`)
        const url=`${process.env.REACT_APP_API_SERVER}manager/profile/photo/${sessionStorage.getItem('userToken')}/${d}`
        setUsrPhoto(url)
        sessionStorage.setItem('usrPhoto',url)
        setTempPhoto(url)
    }

    const cancelUpload=()=>{
      try{
      fileInputRef.current.value=null;
      setIsUpLoading(false)
      setUploadPercentage(0)
      setTempPhoto(resolvePhoto())
      setPickedImage(false)
      setUploadNote(null)
      }catch(err){}
  }

  const countriesList=Object.entries(countries).sort((a,b)=>{
    if (a[1].name < b[1].name) {
        return -1;
    }
    if (a[1].name > b[1].name) {
        return 1;
    }
    return 0;
  }).map((item,index)=>{
  // console.log(item)
    return(
        <option key={'country'+index} value={item[1].name}>{item[1].name}</option>

    )
  })



  const selectCountry=(countryName)=>{

    try{
      var telPrefix=Object.entries(countries).filter(item=>item[1].name===countryName)[0][1].phone[0]
    }catch(err){
       telPrefix=''
    }
    setRecord({...record,Country:countryName,telPrefix:telPrefix})

  }

  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const saveProfile=(e)=>{
    e.preventDefault()
    setSaveNote(null)
    axios.post(process.env.REACT_APP_API_SERVER+'manager/profile',record,{
      headers: {
          'Authorization': 'Bearer '+sessionStorage.getItem("mngapiToken")
          }
      })
    .then(res=>{
        if (res.data.err==0){
          loadProfile()
          sessionStorage.setItem('userName',record.FullName)
          setSaveNote({tone:'good',title:'Profile updated',text:'Your details have been saved.'})
        }else{
          setSaveNote({tone:'bad',title:'Not saved',text:'The server rejected the change. Check your details and try again.'})
        }

        setIsLoading(false)
    }).catch(err=>{
        //console.log(err)
        setIsLoading(false)
        setSaveNote({tone:'bad',title:'Not saved',text:'The server could not be reached. Check your connection and try again.'})

    })

  }

  /* ---------- derived display values ---------- */

  const photoSrc=(typeof tempPhoto === 'string') ? tempPhoto.trim() : ''
  const showPhoto=(photoSrc !== '') && !photoBroken

  // Just the name to show under the face. Turning it into a monogram is Avatar's
  // job now, so this screen no longer spells initials of its own.
  const photoName=(()=>{
    try{
      return record.FullName || sessionStorage.getItem('userName') || [firstName,lastName].filter(Boolean).join(' ') || ''
    }catch(xerr){
      return record.FullName || ''
    }
  })()

  // May arrive as a JSON string or as a plain array — never print it raw.
  const planCountries=(()=>{
    try{
      const raw=record.appCountries
      if (!raw) return []
      const parsed=(typeof raw === 'string') ? JSON.parse(raw) : raw
      if (!Array.isArray(parsed)) return []
      return parsed.map(item=>{
        if (item && typeof item === 'object') return item.label || item.name || item.Country || ''
        if (typeof item === 'string') return item
        return ''
      }).filter(name=>typeof name === 'string' && name.trim() !== '')
    }catch(xerr){
      return []
    }
  })()

  const productTitle=(()=>{
    try{
      return sessionStorage.getItem('ProductTitle') || 'n/a'
    }catch(xerr){
      return 'n/a'
    }
  })()

  const endDate=(()=>{
    try{
      const parts=String(record.EndDateDisplay || '').split(' ')
      const text=[parts[2],parts[1],parts[3]].filter(part=>part !== undefined && part !== '').join(' ').trim()
      // Login never stores an end date, so the sidebar plan card has nothing to show.
      // Cache it here — this is the only screen that fetches it.
      if (text){
        try{ sessionStorage.setItem('ProductEndDate',text) }catch(serr){ /* not cached */ }
      }
      return text || 'n/a'
    }catch(xerr){
      return 'n/a'
    }
  })()

  const note=(data)=>{
    if (!data) return null
    return (
      <div className={'pf-note '+(data.tone==='good' ? 'pf-note-good' : 'pf-note-bad')} role="status" aria-live="polite">
        <b>{data.title}</b>
        {data.text}
      </div>
    )
  }

    return (
        <div className="profile-page">

          <div className="pf-grid">

            {/* ---------- PHOTO ---------- */}
            <Panel
              className="pf-col-photo"
              title="Profile photo"
              subtitle="Shown next to your name across the manager"
            >
              <div className="pf-photo-stage">

                {/* The frame keeps its 168px slot and shadow; the face inside it is the
                    shared Avatar at 166px — the frame's content box — so the uploaded
                    photo, the local data: preview and the initials fallback are all one
                    component. A picked file arrives as a data: URL and renders as `src`. */}
                <div className="pf-photo-frame">
                  <Avatar
                    src={showPhoto ? photoSrc : undefined}
                    name={photoName}
                    size={166}
                  />
                </div>

                <input
                    type="file"
                    accept="image/*"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                />

                {!isUploading && !pickedImage &&
                  <>
                    <p className="pf-photo-hint">Square JPG or PNG works best. The image is cropped to a circle.</p>
                    <div className="pf-photo-actions">
                      <Btn onClick={selectMedia}>{showPhoto ? 'Change photo' : 'Select photo'}</Btn>
                    </div>
                  </>
                }

                {pickedImage &&
                  <>
                    <p className="pf-photo-hint">Preview only — nothing is saved until you upload.</p>
                    <div className="pf-photo-actions">
                      <Btn variant="accent" onClick={()=>uploadFile(file)}>Upload</Btn>
                      <Btn onClick={()=>cancelUpload()}>Cancel</Btn>
                    </div>
                  </>
                }

                {isUploading &&
                  <>
                    <div className="pf-progress">
                      <div className="pf-progress-row">
                        <span className="mono">Uploading</span>
                        <span className="pf-progress-value">{uploadPercentage}%</span>
                      </div>
                      <div
                        className="pf-progress-track"
                        role="progressbar"
                        aria-valuenow={uploadPercentage}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      >
                        <div className="pf-progress-fill" style={{width:uploadPercentage+'%'}}></div>
                      </div>
                    </div>
                    <div className="pf-photo-actions">
                      <Btn onClick={()=>cancelUpload()}>Cancel</Btn>
                    </div>
                  </>
                }

                {note(uploadNote)}

              </div>
            </Panel>

            {/* ---------- DETAILS ---------- */}
            <Panel
              className="pf-col-form"
              title="Your details"
              subtitle="Name, contact and sign-in password"
            >
              <Form onSubmit={saveProfile}>

                <Form.Group className="pf-field">
                  <Form.Label>Full Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={record.FullName}
                    onChange={(e)=>setRecord({...record,FullName:e.target.value})}
                    required
                    />
                </Form.Group>

                <Form.Group className="pf-field">
                  <Form.Label>VAT</Form.Label>
                  <Form.Control
                    type="text"
                    name="vat"
                    value={record.VatNumber}
                    onChange={(e)=>setRecord({...record,VatNumber:e.target.value})}
                    required
                    />
                </Form.Group>

                <Form.Group className="pf-field">
                  <Form.Label>Country</Form.Label>
                    <Form.Control required as="select" value={record.Country} onChange={(e)=>selectCountry(e.target.value)}>
                      <option value=''>[Select Country]</option>{countriesList}
                    </Form.Control>
                  </Form.Group>

                <Form.Group className="pf-field">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={record.Email}
                    onChange={(e)=>setRecord({...record,Email:e.target.value})}
                    required
                    disabled
                    />
                </Form.Group>

                <Form.Group className="pf-field">
                  <Form.Label>Phone</Form.Label>
                  <Form.Control
                    type="tel"
                    name="phone"
                    value={record.Telephone}
                    onChange={(e)=>setRecord({...record,Telephone:e.target.value})}
                    required
                    />
                </Form.Group>

                  <Form.Group className="pf-field pf-field-pw">
                  <Form.Label>Password</Form.Label>

                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={record.Password}
                      onChange={(e)=>setRecord({...record,Password:e.target.value})}
                      placeholder="Enter password"
                      minLength={6}
                      maxLength={12}
                      required
                      />
                      <FontAwesomeIcon
                      className="pf-eye"
                      icon={showPassword ? faEye : faEyeSlash}
                      onClick={togglePasswordVisibility}
                      />
                </Form.Group>

                <div className="pf-form-foot">
                  <Btn variant="accent" className="pf-save" type="submit">
                    Save
                  </Btn>
                  {note(saveNote)}
                </div>
              </Form>
            </Panel>

            {/* ---------- PLAN ---------- */}
            <Panel
              className="pf-col-plan"
              title="Your plan"
              subtitle="Subscription and country coverage"
            >
              <dl className="pf-facts">
                <div className="pf-fact">
                  <dt>Product</dt>
                  <dd>{productTitle}</dd>
                </div>
                <div className="pf-fact">
                  <dt>End date</dt>
                  <dd className="num">{endDate}</dd>
                </div>
              </dl>

              {planCountries.length > 0 &&
                <div className="pf-countries">
                  <div className="mono pf-countries-label">Countries</div>
                  <div className="pf-chips">
                    {planCountries.map((name,index)=>(
                      <span className="pf-chip" key={'appcountry'+index}>{name}</span>
                    ))}
                  </div>
                </div>
              }

              <div className="pf-plan-foot">
                <Btn variant="accent" onClick={()=>{window.location.href='/#/plans'}}>
                  Change plan
                </Btn>
              </div>
            </Panel>

          </div>
        </div>
    )
}
